import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import I18n from '../../../config/locales';

const useStyles = makeStyles(theme => ({
  a: { fill: '#fff;', stroke: '#ff7141;', opacity: 0 },
  c: { fill: 'none;' },
  e: { stroke: 'none;' },
  b: { fontSize: '14px', fontFamily: 'Roboto-Medium, Roboto', fontWeight: 500, fill: '#1a85e2;' },
  d: { fill: '#1a85e2;' }
}));

function ChangeEmail() {
  const classes = useStyles();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="177" height="40" viewBox="0 0 177 40">
      <g transform="translate(-56 -853)">
        <g transform="translate(56 853)">
          <g className={classes.a}>
            <rect className={classes.e} width="156" height="40" rx="2" />
            <rect className={classes.c} x="0.5" y="0.5" width="155" height="39" rx="1.5" />
          </g>
          <text className={classes.b} transform="translate(36 27)">
            <tspan x="0" y="0">
            {I18n.t('accountDetails.changeEmailRequest')}
            </tspan>
          </text>
        </g>
        <g transform="translate(166.65 811.65)">
          <rect className={classes.c} width="23" height="23" transform="translate(-103.65 52.35)" />
          <path
            className={classes.d}
            d="M-83.028,58h-17.512A1.459,1.459,0,0,0-102,59.456V71.134a1.461,1.461,0,0,0,1.459,1.459h17.512a1.461,1.461,0,0,0,1.459-1.459V59.459A1.461,1.461,0,0,0-83.028,58Zm-1.606,1.459-7.15,4.95-7.15-4.95Zm-15.906,11.675,0-11.014L-92.2,65.9a.726.726,0,0,0,.415.13.726.726,0,0,0,.415-.13l8.341-5.774V71.134Z"
            transform="translate(-0.541 -1.622)"
          />
        </g>
      </g>
    </svg>
  );
}

export default ChangeEmail;
